module.exports = __webpack_public_path__ + "static/media/mail-minus.12adc1e0.svg";